var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"pt-4 px-3 pb-2 mt-0 mb-3 overlay-options-field-bg",style:(_vm.field.data.css ? _vm.field.data.css.field : null),attrs:{"value":_vm.value,"type":_vm.numberFieldInputType,"step":_vm.stepSize,"label":_vm.noLabel ? '' : _vm.field.data.label,"placeholder":_vm.field.data.placeholder,"append-icon":_vm.currencyIcon,"required":_vm.field.required,"rules":_vm.field.rules,"disabled":_vm.disabled,"data-cy":"overlay-data-pricefield"},on:{"focus":_vm.onInputFocused,"input":_vm.onPriceChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/OverlayDataPriceField.vue?vue&type=template&id=d5da191a&
// module id = 1713
// module chunks = 5